module.exports = __webpack_public_path__ + "img/chevron_right.5495bfc6.svg";